/* global Messenger */
import * as React from 'react';
import PropTypes from 'prop-types';

// Components
import { ConfirmationModal } from '../../../../../../../../components/ConfirmationModal';

// Hooks
import { useCriteriaStoreRootUuid } from '../../../../../../state/criteria/hooks/useCriteriaStoreRootUuid';
import { useCriteriaStoreParentPredicateUuid } from '../../../../../../state/criteria/hooks/useCriteriaStoreParentPredicateUuid';
import { useCriteriaStoreDeletePredicate } from '../../../../../../state/criteria/hooks/useCriteriaStoreDeletePredicate';

export const DeletePredicateConfirmation = ({ predicateUuid, onClose, onDelete } = {}) => {
    const deletePredicate = useCriteriaStoreDeletePredicate();
    const parentPredicateUuid = useCriteriaStoreParentPredicateUuid(predicateUuid);
    const rootUuid = useCriteriaStoreRootUuid();

    return (
        <ConfirmationModal
            header={`Delete Predicate?`}
            body={`Are you sure you want to delete this predicate?`}
            confirmButtonText={'Yes, Delete'}
            confirmButtonProps={{ appearance: 'destructive', text: true }}
            closeDialog={onClose}
            onConfirm={() => {
                return new Promise((resolve) => {
                    deletePredicate({ predicateUuid: predicateUuid, parentUuid: parentPredicateUuid ?? rootUuid });
                    Messenger.showMessage({
                        type: `info`,
                        title: 'Changes have been applied locally.',
                        message: `In order to save these changes please click save/apply on the criteria modal.`
                    });
                    onDelete();
                    resolve();
                });
            }}
        />
    );
};

DeletePredicateConfirmation.propTypes = {
    predicateUuid: PropTypes.string,
    onClose: PropTypes.func,
    onDelete: PropTypes.func
};
